// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2cNUM","amount":"Amount_amount__2ERsi","tip":"Amount_tip__1xq22","tipHeader":"Amount_tipHeader__rj9Gi","tipsWrap":"Amount_tipsWrap__B_Cvm"};